module.exports = __webpack_public_path__ + "static/media/18_shape_r.a92f38e1.webp";